import { axiosRequest } from '../helpers/axios'

export default function getCandidateHistory(candidateId) {
  return axiosRequest('GET', `/candidates/${candidateId}/history`, null, null)
}
